import Constants from "./constants";
import { LogMessage } from "./helper-func";
export function IsInExtension() {
    return window.location.href.startsWith('chrome-extension://');
}
function _decodeUserInfo(info) {
    return JSON.parse(atob(info));
}
function _encodeUserInfo(info) {
    return btoa(JSON.stringify(info));
}
const userInfoKey = Constants.Keys.UserInfo;
export function GetLocalUserInfo() {
    const userInfo = localStorage.getItem(userInfoKey);
    if (userInfo == null)
        return null;
    return _decodeUserInfo(userInfo);
}
export function SaveLocalUserInfo(userInfo) {
    localStorage.setItem(userInfoKey, _encodeUserInfo(userInfo));
}
export function RemoveLocalUserInfo() {
    localStorage.removeItem(userInfoKey);
}
export function IsUserSignedIn(userInfo) {
    return userInfo != null && userInfo.userToken != null && userInfo.userToken.length > 0;
}
export function GetUserInfoInExtension(callback) {
    chrome.storage.local.get([userInfoKey]).then((result) => {
        LogMessage(`GetUserInfoInExtension: ${JSON.stringify(result)}`);
        if (result && (userInfoKey in result)) {
            const userInfo = _decodeUserInfo(result[userInfoKey]);
            callback(true, userInfo);
        }
        else {
            callback(false, null);
        }
    });
}
export async function GetUserInfoInExtensionAsync() {
    return new Promise((resolve, reject) => {
        GetUserInfoInExtension((success, userInfo) => {
            LogMessage(`GetUserInfoInExtensionAsync: ${success} ${JSON.stringify(userInfo)}`);
            if (success && userInfo) {
                resolve(userInfo);
            }
            else {
                resolve(null);
            }
        });
    });
}
export function RemoveUserInfoInExtension() {
    chrome.storage.local.remove([userInfoKey]);
}
export function SaveUserInfoInExtension(userInfo) {
    const data = {};
    data[userInfoKey] = _encodeUserInfo(userInfo);
    chrome.storage.local.set(data).then(() => {
        LogMessage(`UserInfo ${JSON.stringify(data)} is saved to chrome local storage.`);
    });
}
export function UpdateQuotaEndTimeInExtension(quotaEndTime) {
    GetUserInfoInExtension((success, userInfo) => {
        if (!success || userInfo == null) {
            return;
        }
        LogMessage(`Update quota end time ${quotaEndTime}`);
        if (success && userInfo) {
            userInfo.quotaEndTime = quotaEndTime;
            SaveUserInfoInExtension(userInfo);
        }
    });
}
export const SendUserInfoToExtension = (userInfo) => {
    window.postMessage({
        type: Constants.MessageType.SendUserInfoToExtension,
        userInfo: userInfo,
    }, "*");
};
